<template>
  <div class="vue-tempalte vertical-center inner-block">
    <h3>{{ $t("PASS_SET") }}</h3>
    <b-form @submit.prevent="passwordreset">
      <b-form-group :label="$t('INPUT_EMAIL')" label-for="email">
        <b-form-input
          id="email"
          type="email"
          class="form-control mt-2 mb-3"
          v-model="username"
          required
        />
      </b-form-group>
      <b-form-group :label="$t('NEW_PASS')"  label-for="password">
        <b-form-input
          id="password"
          type="password"
          class="form-control mt-2 mb-3"
          v-model="password"
          minlength="6"
          required
        />
      </b-form-group>
      <b-form-group :label="$t('CONFIRM_CODE')" label-for="confirm">
        <b-form-input
          id="confirm"
          type="textarea"
          class="form-control mt-2 mb-3"
          v-model="confirmationCode"
          required
        />
      </b-form-group>
      <b-button type="submit" variant="primary"> {{ $t("CHANGE_PASS") }}</b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "PasswordReset",
  data() {
    return {
      username: "",
      password: "",
      confirmationCode: "",
    };
  },
  methods: {
    passwordreset() {
      this.$cognito
        .resetPassword(this.username, this.password, this.confirmationCode)
        .then((result) => {
          this.$router.replace("/Login");
        })
        .catch((err) => {
          alert(err.message);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PasswordReset.vue